module.exports = __webpack_public_path__ + "df622832e0cf93ff0b62a1128240cf01.pdf";